import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/WishesPage.scss';
const WishesPage = () => {
  const [wishes, setWishes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const wishesPerPage = 10;
  useEffect(() => {
    fetchWishes();
  }, []);
  const fetchWishes = async () => {
    try {
      setError(null);
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
      console.log('Fetching from:', `${apiUrl}/api/wishes`);
      const response = await axios.get(`${apiUrl}/api/wishes`, {
        timeout: 30000,
        headers: {
          'Content-Type': 'application/json'
        }
      });
      setWishes(response.data);
    } catch (error) {
      console.error('Error fetching wishes:', error);
      setError('เชื่อมต่อฐานข้อมูลไม่ได้ กรุณาลองใหม่อีกครั้ง');
      setWishes([]);
    } finally {
      setLoading(false);
    }
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  const totalPages = Math.ceil(wishes.length / wishesPerPage);
  const startIndex = (currentPage - 1) * wishesPerPage;
  const currentWishes = wishes.slice(startIndex, startIndex + wishesPerPage);
  const goToPage = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
    <div className="wishes-page">
      <a href="/" className="back-link">กลับหน้าแรก</a>
      <div className="wishes-header">
        <h1>คำอวยพรทั้งหมด</h1>
        <p>รวม {wishes.length} ข้อความ | หน้า {currentPage} จาก {totalPages}</p>
      </div>
      {loading ? (
        <div className="loading">กำลังโหลด...</div>
      ) : error ? (
        <div className="error">{error}</div>
      ) : wishes.length === 0 ? (
        <div className="no-wishes">ยังไม่มีคำอวยพร</div>
      ) : (
        <>
          <div className="wishes-list">
            {currentWishes.map((wish) => (
              <div key={wish.id} className="wish-card">
                <div className="wish-header">
                  <h3>{wish.guest_name}</h3>
                  <span className="wish-date">{formatDate(wish.created_at)}</span>
                </div>
                <p className="wish-message">{wish.message}</p>
              </div>
            ))}
          </div>
          {totalPages > 1 && (
            <div className="pagination">
              <button 
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
                className="page-btn"
              >
                ก่อนหน้า
              </button>
              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index + 1}
                  onClick={() => goToPage(index + 1)}
                  className={`page-btn ${currentPage === index + 1 ? 'active' : ''}`}
                >
                  {index + 1}
                </button>
              ))}
              <button 
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="page-btn"
              >
                ถัดไป
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default WishesPage;